import { useParams } from "react-router-dom";

export default function ServiceDetail() {
  const { categorySlug, serviceSlug } = useParams();

  // Fetch les infos du service depuis ton API avec le slug
  return (
    <div>
      <h1>Détail du service</h1>
      <p>Catégorie : {categorySlug}</p>
      <p>Service : {serviceSlug}</p>
    </div>
  );
}
